import React from 'react';
import { isMobile } from 'react-device-detect';
import parse from 'html-react-parser';
import styled from 'styled-components';
import IDHelpers from '../../../../../../../core/helpers/IDHelper';
import { Block, Text, Heading, Icon } from '../../../../../../components';
import { BackButton, InteractiveButton } from '../../../../components';
import clockIcon from '../../../../../../../assets/icons/icon-clock-black.svg';
import moneyIcon from '../../../../../../../assets/icons/icon-money.svg';
import lineIcon from '../../../../../../../assets/icons/icon-line-v2.svg';
import calendarIcon from '../../../../../../../assets/icons/icon-calendar.svg';
import Spinner from '../../../../../../components/Spinner';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import constants from '../../../../../../../core/constants';
import Modal from '../../../../components/Modal/Modal';
import NotAvailable from '@/presentation/modules/procedures/components/Modals/NotAvailable';
import {
  ErrorMessage,
  ContainerProcedure
} from '../../../certificates-constancies/type1/info/components';
import PinProcedure from '../../../../components/PinProcedure/PinProcedure';

const WrapLinkMoreInfo = styled.div`
  a {
    color: #5b36f2;
    text-decoration: underline;
    font-weight: bold;
  }
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const ChangeCareerCampusModalityInfoView = (props: any) => {
  const {
    procedureSelectedInfo,
    selectedRequest,
    handleNewRequest,
    handleBack,
    handleExistRequest,
    handleCloseModalConfirmation,
    handleCloseModalNotAvailable,
    handleCloseModalError,
    showModalConfirmation,
    showModalNotAvailable,
    showModalError,
    modalErrorTitle,
    modalErrorMessage
  } = props;

  const pin1Safe = parse(procedureSelectedInfo?.pin1 || '');
  const pin2Safe = parse(procedureSelectedInfo?.pin2 || '');
  const linkSafe = parse(procedureSelectedInfo?.moreInfo || '');

  return (
    <div data-testid="cmp-changecareercampusinfoview">
      <ContainerProcedure>
        <Block customized justifyContent="flex-start" margin="0px 0px 16px">
          <BackButton onClick={handleBack} />
        </Block>

        <Block customized justifyContent="flex-start">
          <Heading
            text={
              procedureSelectedInfo
                ? procedureSelectedInfo?.name
                : selectedRequest?.name
            }
            level={2}
            color="var(--text-text02)"
            size={18}
            lineHeight={isMobile ? 28 : 24}
            fontWeight="900"
            className=""
            align="flex-start"
          />
          {!procedureSelectedInfo && <Spinner />}
          {procedureSelectedInfo && (
            <>
              {isMobile ? (
                <Block
                  customized
                  flexDirection="column"
                  alignItems="center"
                  margin="8px 0px 0px 0px"
                >
                  <Block customized flexDirection="row">
                    <Icon
                      customized
                      maxWidth="16.9px"
                      height="15px"
                      margin="0px 4.67px 0px 0px"
                    >
                      <img src={moneyIcon} alt="other" />
                    </Icon>
                    <Text
                      color="#161D1F"
                      fontSize="14px"
                      lineHeight="20px"
                      fontWeight="400"
                    >
                      Costo:{' '}
                      <Text fontWeight="700">
                        S/. {procedureSelectedInfo?.amount}.00
                      </Text>
                    </Text>
                  </Block>
                  <Block customized flexDirection="row" margin="6px 0px 0px">
                    <Icon
                      customized
                      maxWidth="13.33px"
                      margin="0px 5.33px 0px 0px"
                    >
                      <img src={calendarIcon} alt="other" />
                    </Icon>
                    <Text
                      color="#161D1F"
                      fontSize="12px"
                      lineHeight="16px"
                      fontWeight="400"
                    >
                      {procedureSelectedInfo?.endDate || ''}
                    </Text>
                    <Icon
                      customized
                      maxWidth="1px"
                      height="13px"
                      margin="0px 0px 0px 16px"
                    >
                      <img src={lineIcon} alt="other" />
                    </Icon>
                    <Icon
                      customized
                      maxWidth="13.33px"
                      margin="0px 5.33px 0px 17.33px"
                    >
                      <img src={clockIcon} alt="other" />
                    </Icon>
                    <Text
                      color="#161D1F"
                      fontSize="12px"
                      lineHeight="16px"
                      fontWeight="400"
                    >
                      {procedureSelectedInfo?.duration || ''}
                    </Text>
                  </Block>
                </Block>
              ) : (
                <Block
                  customized
                  flexDirection="row"
                  alignItems="center"
                  margin="8px 0px 0px 0px"
                >
                  <Icon
                    customized
                    maxWidth="16.9px"
                    height="15px"
                    margin="0px 4.67px 0px 0px"
                  >
                    <img src={moneyIcon} alt="other" />
                  </Icon>
                  <Text
                    color="#161D1F"
                    fontSize="14px"
                    lineHeight="20px"
                    fontWeight="400"
                  >
                    Costo:{' '}
                    <Text fontWeight="700">
                      S/. {procedureSelectedInfo?.amount}.00
                    </Text>
                  </Text>
                  <Icon
                    customized
                    maxWidth="1px"
                    height="13px"
                    margin="0px 0px 0px 16px"
                  >
                    <img src={lineIcon} alt="other" />
                  </Icon>
                  <Icon
                    customized
                    maxWidth="13.33px"
                    margin="0px 5.33px 0px 17.33px"
                  >
                    <img src={calendarIcon} alt="other" />
                  </Icon>
                  <Text
                    color="#161D1F"
                    fontSize="12px"
                    lineHeight="16px"
                    fontWeight="400"
                  >
                    {procedureSelectedInfo?.endDate || ''}
                  </Text>
                  <Icon
                    customized
                    maxWidth="1px"
                    height="13px"
                    margin="0px 0px 0px 16px"
                  >
                    <img src={lineIcon} alt="other" />
                  </Icon>
                  <Icon
                    customized
                    maxWidth="13.33px"
                    margin="0px 5.33px 0px 17.33px"
                  >
                    <img src={clockIcon} alt="other" />
                  </Icon>
                  <Text
                    color="#161D1F"
                    fontSize="12px"
                    lineHeight="16px"
                    fontWeight="400"
                  >
                    {procedureSelectedInfo?.duration || ''}
                  </Text>
                </Block>
              )}
              {/* aqui va el card */}
              <Block
                customized
                maxWidth={isMobile ? '100%' : '744px'}
                backgroundColor="#fff"
                padding="16px"
                borderRadius="8px"
                margin="12px 0px 16px 0px"
              >
                <Block customized margin="0px 0px 16px 0px">
                  <WrapLinkMoreInfo>
                    <ul
                      style={{
                        listStyleType: 'disc',
                        display: 'block',
                        marginLeft: 16
                      }}
                    >
                      <li key={IDHelpers.generateID()}>{linkSafe}</li>
                    </ul>
                  </WrapLinkMoreInfo>
                </Block>
                <Heading
                  text="¿Qué requisitos necesito?"
                  level={3}
                  color="var(--text-text02)"
                  size={14}
                  lineHeight={20}
                  fontWeight="700"
                  className=""
                  align="flex-start"
                  width="100%"
                />
                <Block customized margin="4px 0px 0px 0px">
                  <ul
                    style={{
                      listStyleType: 'disc',
                      display: 'block',
                      marginLeft: 16
                    }}
                  >
                    {procedureSelectedInfo?.requirements?.map((r: string) => (
                      <li key={IDHelpers.generateID()}>{r}</li>
                    ))}
                  </ul>
                </Block>
                <PinProcedure pinText={pin2Safe} />
                <PinProcedure pinText={pin1Safe} />
              </Block>

              {/* aqui va el card */}
              <Block
                customized
                maxWidth={isMobile ? '100%' : '744px'}
                backgroundColor="#fff"
                padding="16px"
                borderRadius="8px"
                margin="12px 0px 0px 0px"
              >
                <Heading
                  text="Pasos a seguir:"
                  level={3}
                  color="var(--text-text02)"
                  size={14}
                  lineHeight={20}
                  fontWeight="700"
                  className=""
                  align="flex-start"
                  width="100%"
                />
                <Block
                  customized
                  margin="12px 0px 0px 16px"
                  style={{ width: 'auto' }}
                >
                  <ol style={{ listStyle: 'decimal' }}>
                    {procedureSelectedInfo?.stepsToFollow.map((r: string) => (
                      <li key={IDHelpers.generateID()}>{r}</li>
                    ))}
                  </ol>
                </Block>
              </Block>

              <InteractiveButton
                bkgColorEnabled="#5B36F2"
                bkgColorHover="#745EF6"
                bkgColorFocus="#4318CD"
                bkgColorPressed="#4318CD"
                customized
                backgroundColor="#5B36F2"
                padding="10px 16px"
                borderRadius="4px"
                margin="40px 0px 0px 0px"
                width={isMobile ? '100%' : '83px'}
                onClick={handleNewRequest}
                justifyContent={isMobile ? 'center' : 'flex-start'}
                alignContent={isMobile ? 'center' : 'flex-start'}
                alignItems={isMobile ? 'center' : 'flex-start'}
              >
                <Text
                  color="#FFFFFF"
                  fontSize="14px"
                  lineHeight="20px"
                  fontWeight="700"
                  textAlign={isMobile ? 'center' : 'left'}
                >
                  Solicitar
                </Text>
              </InteractiveButton>

              <Modal
                show={showModalConfirmation}
                handleClose={handleCloseModalConfirmation}
              >
                <RequestExist handleClick={handleExistRequest} />
              </Modal>
              <Modal
                show={showModalNotAvailable}
                handleClose={handleCloseModalNotAvailable}
              >
                <NotAvailable handleClick={handleCloseModalNotAvailable} />
              </Modal>
              <Modal show={showModalError} handleClose={handleCloseModalError}>
                <ErrorMessage
                  handleClick={handleCloseModalError}
                  title={modalErrorTitle}
                  message={modalErrorMessage}
                />
              </Modal>
            </>
          )}
        </Block>
      </ContainerProcedure>
    </div>
  );
};

export default ChangeCareerCampusModalityInfoView;
